import { render } from "./PlatformManagement.vue?vue&type=template&id=489246a9&scoped=true"
import script from "./PlatformManagement.vue?vue&type=script&lang=js"
export * from "./PlatformManagement.vue?vue&type=script&lang=js"

import "./PlatformManagement.vue?vue&type=style&index=0&id=489246a9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489246a9"]])

export default __exports__